import React from 'react';
import "./ui.css";

const EmptyComp = ({text}) => {
  return (
    <div className='empty_comp'>
        <p>{text}</p>
    </div>
  )
}

export default EmptyComp